import React from "react";
import { RouteComponentProps } from "react-router";
import { checkIfDirectRoute } from "@utils/navigationUtils";
import { TRAVEL_REQUEST_SLIDER } from "@navigation";
import { bonlivaPipelineTheme } from "@bonliva-crm/ui";
import { TravelRequestSearchFiltersProvider } from "./hooks/use-travel-request-search-filters";
import { Box, ThemeProvider } from "@material-ui/core";
import { TravelRequestSearchLayout } from "./travel-request-search-layout";

type Props = RouteComponentProps<any>;

export function TravelRequestSearchPage(props: Props) {
  const { match } = props;
  const { url } = match;
  return (
    <>
      {catchDirectUrl(url)}
      <ThemeProvider theme={bonlivaPipelineTheme}>
        <TravelRequestSearchFiltersProvider>
          <Box
            width="100%"
            height="100%"
            fontFamily={bonlivaPipelineTheme.typography.fontFamily}
          >
            <TravelRequestSearchLayout />
          </Box>
        </TravelRequestSearchFiltersProvider>
      </ThemeProvider>
    </>
  );
}

function catchDirectUrl(url) {
  return checkIfDirectRoute(
    [`${url}/:travelRequestId(\\S{24})`],
    TRAVEL_REQUEST_SLIDER,
    ({ travelRequestId }) => {
      if (travelRequestId) {
        // return new KitProfileLocation(kitId);
      }
    }
  );
}
